<template>
    <div ref="pdfTemple" class="pdfTemple" style="position:absolute;bottom:-999px;width:1920px;padding:20px;">
        <div v-if="data.innerOrderSn" class="invoice-box">
			<table cellpadding="0" cellspacing="0">
				<tr class="top">
					<td colspan="5">
						<table>
							<tr>
								<td class="title" style="width:50%">
									<b>DELIVERY NOTE</b>
									<p>Order ID: #{{ data.innerOrderSn }}</p>
									<p>Sales Order Number: {{ data.orderSn }}</p>
								</td>
							</tr>
						</table>
					</td>
				</tr>
				<tr class="information">
					<td colspan="5">
						<table>
							<tr>
								<td style="width:50%">
									From:
									62 Goodall Close, Dandenong South <br />
									VIC 3175, Australia
									Phone: 0391176197
								</td>
								<td>
									Ship To:
									{{ data.receiverAddress }}, {{ data.receiverAddress2 }}.<br />
									{{ data.receiverCity }}, {{ data.receiverProvince }}<br />
									{{ data.receiverCountry }} - {{ data.receiverPostcode }}<br />
									{{ data.receiverName }}<br />
									{{ data.receiverMobile }}<br />
								</td>
							</tr>
						</table>
					</td>
				</tr>
				<tr class="heading">
					<td>SKU</td>
					<td style="text-align: right;">Name</td>
					<td style="text-align: right;">Qty</td>
				</tr>
                <tr v-for="(item,index) in data.skuDTOList" :key="index">
                    <td>{{ item.skuCode }}</td>
                    <td>{{ item.skuName }}</td>
                    <td>{{ item.number }}</td>
                </tr>
			</table>
		</div>
    </div>
  </template>

  <script>
  import html2canvas from 'html2canvas';
  import JsPDF from 'jspdf';
  import printJS from 'print-js';
  export default {
      props: {
          data: {
              type: Object,
              default: null,
          }
      },
      methods: {
          async exportPage() {
            const PDFView = this.$refs.pdfTemple;
            html2canvas(PDFView, {
              allowTaint: true,
              useCORS: true,
              dpi: 120, // 图片清晰度问题
              background: '#FFFFFF', // 如果指定的div没有设置背景色会默认成黑色,这里是个坑
            }).then(canvas => {
              // 未生成pdf的html页面高度
              var leftHeight = canvas.height;
              var a4Width = 841.89;
              var a4Height = 595.28; // A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
              // 一页pdf显示html页面生成的canvas高度;
              var a4HeightRef = Math.floor((canvas.width / a4Width) * a4Height);

              // pdf页面偏移
              var position = 0;
              var pageData = canvas.toDataURL('image/jpeg', 1.0);
              var pdf = new JsPDF('l', 'pt', 'a4'); // A4纸，纵向
              var index = 1; var canvas1 = document.createElement('canvas'); var height;
              pdf.setDisplayMode('fullwidth', 'continuous', 'FullScreen');

              function createImpl(canvas) {
                console.log(leftHeight, a4HeightRef);
                if (leftHeight > 0) {
                  index++;
                  var checkCount = 0;
                  if (leftHeight > a4HeightRef) {
                    var i = position + a4HeightRef;
                    for (i = position + a4HeightRef; i >= position; i--) {
                      var isWrite = true;
                      for (var j = 0; j < canvas.width; j++) {
                        var c = canvas.getContext('2d').getImageData(j, i, 1, 1).data;
                        if (c[0] != 0xff || c[1] != 0xff || c[2] != 0xff) {
                          isWrite = false;
                          break;
                        }
                      }
                      if (isWrite) {
                        checkCount++;
                        if (checkCount >= 10) {
                          break;
                        }
                      } else {
                        checkCount = 0;
                      }
                    }
                    height = Math.round(i - position) || Math.min(leftHeight, a4HeightRef);
                    if (height <= 0) {
                      height = a4HeightRef;
                    }
                  } else {
                    height = leftHeight;
                  }
                  canvas1.width = canvas.width;
                  canvas1.height = height;
                  console.log(index, 'height:', height, 'pos', position);
                  var ctx = canvas1.getContext('2d');
                  ctx.drawImage(canvas, 0, position, canvas.width, height, 0, 0, canvas.width, height);
                  // var pageHeight = Math.round((a4Width / canvas.width) * height);
                  // pdf.setPageSize(null, pageHeight)
                  if (position != 0) {
                    pdf.addPage();
                  }
                  pdf.addImage(
                    canvas1.toDataURL('image/jpeg', 1.0), 'JPEG',
                    10, 10, a4Width, (a4Width / canvas1.width) * height
                  );
                  leftHeight -= height;
                  position += height;
                  if (leftHeight > 0) {
                    setTimeout(createImpl, 500, canvas);
                  } else {
                    pdf.save(`${this.$t('route.BusinessBillingDeliveryNote')}.pdf`);
                  }
                }
              }

              // 当内容未超过pdf一页显示的范围，无需分页
              if (leftHeight < a4HeightRef) {
                pdf.addImage(pageData, 'JPEG', 0, 0, a4Width, (a4Width / canvas.width) * leftHeight);
                pdf.save(`${this.$t('route.BusinessBillingDeliveryNote')}.pdf`);
              } else {
                try {
                  pdf.deletePage(0);
                  setTimeout(createImpl, 500, canvas);
                } catch (err) {
                  console.log(err);
                }
              }
            });
          },

          isSplit (nodes, index, pageHeight) {
              // 计算当前这块dom是否跨越了a4大小，以此分割
              return !!(nodes[index].offsetTop + nodes[index].offsetHeight < pageHeight && nodes[index + 1] && nodes[index + 1].offsetTop + nodes[index + 1].offsetHeight > pageHeight);
          },
          // 导出为pdf
          exportPDF() {
              // pdfTemple ref
              const PDFView = this.$refs.pdfTemple;
              // 获取分割dom，此处为class类名为item的dom
              const lableListID = document.getElementsByClassName('emptyItem');
              const pageHeight = PDFView.scrollWidth / 841.89 * 595.28; // (横版pdf)
              // 进行分割操作，当dom内容已超出a4的高度，则将该dom前插入一个空dom，把他挤下去，分割
              for (let i = 0; i < lableListID.length; i++) {
                  const multiple = Math.ceil((lableListID[i].offsetTop + lableListID[i].offsetHeight) / pageHeight);
                  if (this.isSplit(lableListID, i, multiple * pageHeight)) {
                      const divParent = lableListID[i].parentNode; // 获取该div的父节点
                      const newNode = document.createElement('div');
                      newNode.className = 'emptyDiv';
                      newNode.style.background = '#ffffff';
                      const _H = multiple * pageHeight - (lableListID[i].offsetTop + lableListID[i].offsetHeight);
                      console.log(pageHeight, lableListID[i].offsetTop, lableListID[i].offsetHeight);
                      newNode.style.height = _H + 'px';
                      newNode.style.width = '100%';
                      const next = lableListID[i].nextSibling; // 获取div的下一个兄弟节点
                      // 判断兄弟节点是否存在
                      if (next) {
                          // 存在则将新节点插入到div的下一个兄弟节点之前，即div之后
                          divParent.insertBefore(newNode, next);
                      } else {
                          // 不存在则直接添加到最后,appendChild默认添加到divParent的最后
                          divParent.appendChild(newNode);
                      }
                  }
              }

              html2canvas(PDFView, {
                  useCORS: true, // 是否尝试使用CORS从服务器加载图像
                  allowTaint: true,
                  dpi: 300, // 解决生产图片模糊
                  scale: 3, // 清晰度--放大倍数
              }).then(
                  (canvas) => {
                      const contentWidth = canvas.width;
                      const contentHeight = canvas.height;
                      // let pageHeight = contentWidth / 592.28 * 841.89 // 一页pdf显示html页面生成的canvas高度;
                      const pageHeight = contentWidth / 841.89 * 595.28; // 一页pdf显示html页面生成的canvas高度(横版pdf);
                      let leftHeight = contentHeight; // 未生成pdf的html页面高度
                      let position = 0; // pdf页面偏移

                      // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
                      const imgWidth = 808; // 宽度（横版pdf）
                      const imgHeight = 841.89 / contentWidth * contentHeight; // （横版pdf）
                      const pageData = canvas.toDataURL('image/jpeg', 1.0);
                      const PDF = new JsPDF('l', 'pt', 'a4');
                      if (leftHeight < pageHeight) {
                          PDF.addImage(pageData, 'JPEG', 20, 20, imgWidth, imgHeight);
                      } else {
                          while (leftHeight > 0) {
                              PDF.addImage(pageData, 'JPEG', 20, position, imgWidth, imgHeight);
                              leftHeight -= pageHeight;
                              position -= 595.28; // (横版pdf)
                              // position -= 841.89
                              if (leftHeight > 0) {
                                  PDF.addPage();
                              }
                          }
                      }
                      PDF.save('b.pdf'); // 下载标题
                      // // 将前面处理内容分割问题在页面中加上的空白占位结点去掉
                      const emptyDiv = document.getElementsByClassName('emptyDiv');
                      for (let i = 0; i < emptyDiv.length; i++) {
                          emptyDiv[i].remove();
                          i = i - 1;
                      }
              });
          },
          goPrint() {
              html2canvas(this.$refs.pdfTemple, {
                  allowTaint: true,
                  taintTest: false,
                  useCORS: true,
                  dpi: window.devicePixelRatio * 4,
                  scale: 4,
                  logging: true, // 日志开关，便于查看html2canvas的内部执行流程
              }).then((canvas) => {
                  const url = canvas.toDataURL();
                  printJS({
                      printable: url, // 要打印的id
                      type: 'image',
                      style: '@page{size:auto;margin: 0cm 1cm 0cm 1cm;}' // 去除页眉页脚
                  });
              });
          },
      }
  };
  </script>
  <style lang="scss" scoped>
  p {
        font-size: 20px;
        line-height: 25px;
    }
    .invoice-box {
        margin: auto;
        padding: 0px;
        font-size: 20px;
        line-height: 30px;
        color: #555;
    }

    .invoice-box table {
        width: 100%;
        line-height: inherit;
        text-align: left;
    }

    .invoice-box table td , .invoice-box table th {
        padding: 5px;
        vertical-align: top;
    }

    .invoice-box table tr td:nth-child(2) {
        text-align: right;
    }

    .invoice-box table tr.top table td {
        padding-bottom: 20px;
    }

    .invoice-box table tr.top table td.title {
        font-size: 45px;
        line-height: 45px;
        color: #333;
    }

    .invoice-box table tr.information table td {
        padding-bottom: 1px;
    }

    .invoice-box table tr.heading td {
        background: #eee;
        border-bottom: 1px solid #ddd;
        font-weight: bold;
    }

    .invoice-box table tr.details td {
        padding-bottom: 2px;
    }

    .invoice-box table tr.item td {
        border-bottom: 1px solid #eee;
    }

    .invoice-box table tr.item.last td {
        border-bottom: none;
    }

    .invoice-box table tr.total td:nth-child(2) {
        border-top: 1px solid #eee;
        font-weight: bold;
    }

    @media only screen and (max-width: 600px) {
        .invoice-box table tr.top table td {
            width: 100%;
            display: block;
            text-align: center;
        }

        .invoice-box table tr.information table td {
            width: 100%;
            display: block;
            text-align: center;
        }
    }
    table, th,td {
    border: 0.1rem solid #9e9e9e;
    }
    /** RTL **/
    .invoice-box.rtl {
        direction: rtl;
        font-family: Tahoma, 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
    }

    .invoice-box.rtl table {
        text-align: right;
    }

    .invoice-box.rtl table tr td:nth-child(2) {
        text-align: left;
    }
  </style>
